var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.875,
    height: 35.175,
    viewBox: "0 0 41.875 35.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-bag",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M33.859,29.475a7.689,7.689,0,0,1-7.814-7.538A7.689,7.689,0,0,1,33.859,14.4H38.2V11.05A3.416,3.416,0,0,0,34.727,7.7H32.991V4.35A3.416,3.416,0,0,0,29.518,1H5.209A5.154,5.154,0,0,0,.089,5.186,1.554,1.554,0,0,0,0,5.606V31.15a5.126,5.126,0,0,0,5.209,5.025H34.727a3.416,3.416,0,0,0,3.473-3.35v-3.35ZM3.473,6.025A1.708,1.708,0,0,1,5.209,4.35H29.518V7.7H5.209A1.708,1.708,0,0,1,3.473,6.025Z",
    transform: "translate(0)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M28.936,10.5H22.027a5.527,5.527,0,0,0,0,11.054h6.909a1.382,1.382,0,0,0,1.382-1.382V11.882A1.382,1.382,0,0,0,28.936,10.5Zm-6.909,7.37a1.842,1.842,0,1,1,1.842-1.842A1.843,1.843,0,0,1,22.027,17.87Z",
    transform: "translate(11.557 6.063)",
    fill: "#4e3057"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.f9dc45f741254a2f40fa7a68a4bc0024.svg";
export { ForwardRef as ReactComponent };